// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2KuGJ","actionsCol":"EnrolledClinics_actionsCol__1rUq6"};